import { mockReferralDB } from './mockDb';
import type { Stakeholder, StakeholderFormData } from '../types';

export const stakeholderService = {
  async getAll(): Promise<Stakeholder[]> {
    await new Promise(resolve => setTimeout(resolve, 100));
    return mockReferralDB.getStakeholders();
  },

  async getById(id: string): Promise<Stakeholder> {
    await new Promise(resolve => setTimeout(resolve, 100));
    const stakeholder = mockReferralDB.getStakeholder(id);
    if (!stakeholder) throw new Error('Stakeholder not found');
    return stakeholder;
  },

  async getByCode(code: string): Promise<Stakeholder | null> {
    await new Promise(resolve => setTimeout(resolve, 100));
    return mockReferralDB.getStakeholderByCode(code) || null;
  },

  async create(data: StakeholderFormData): Promise<Stakeholder> {
    await new Promise(resolve => setTimeout(resolve, 200));
    return mockReferralDB.createStakeholder(data);
  },

  async update(id: string, data: Partial<StakeholderFormData>): Promise<Stakeholder> {
    await new Promise(resolve => setTimeout(resolve, 200));
    const updated = mockReferralDB.updateStakeholder(id, data);
    if (!updated) throw new Error('Stakeholder not found');
    return updated;
  },

  async delete(id: string): Promise<void> {
    await new Promise(resolve => setTimeout(resolve, 200));
    const updated = mockReferralDB.updateStakeholder(id, { active: false });
    if (!updated) throw new Error('Stakeholder not found');
  },
};
